import { render, staticRenderFns } from "./DocumentSynthesisField.vue?vue&type=template&id=7ef6c29b"
import script from "./DocumentSynthesisField.vue?vue&type=script&lang=ts"
export * from "./DocumentSynthesisField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports